/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ConcreteRequest } from 'relay-runtime';
export type EnquirySourceTypeEnum = "agency_pages" | "mobile_app" | "portal" | "price_pages" | "unknown";
export type PropertySearchNotification = "daily" | "never" | "weekly";
export type CreateEnquiryInput = {|
  enquiry: EnquiryCreateInput,
  clientMutationId?: ?string,
|};
export type EnquiryCreateInput = {|
  emailAddress: string,
  source?: ?EnquirySourceTypeEnum,
  userId?: ?string,
  buyerLeadId?: ?string,
  lotId?: ?string,
  productId?: ?string,
  portalId?: ?string,
  step?: ?number,
  notify?: ?boolean,
  isVisit?: ?boolean,
  visitDate?: ?string,
  callTimes?: ?$ReadOnlyArray<?string>,
  objectRef?: ?string,
  listingLink?: ?string,
  title?: ?string,
  lastName?: ?string,
  firstName?: ?string,
  phoneNumber?: ?string,
  address?: ?string,
  postcode?: ?string,
  locality?: ?string,
  country?: ?string,
  message?: ?string,
  responseActivityId?: ?string,
  processed?: ?boolean,
  propertySearchNotification?: ?PropertySearchNotification,
|};
export type DevelopmentEnquiryFormUpsertMutationVariables = {|
  input: CreateEnquiryInput
|};
export type DevelopmentEnquiryFormUpsertMutationResponse = {|
  +createEnquiry: ?{|
    +enquiry: ?{|
      +id: string
    |},
    +errors: ?{|
      +productId: ?string
    |},
  |}
|};
export type DevelopmentEnquiryFormUpsertMutation = {|
  variables: DevelopmentEnquiryFormUpsertMutationVariables,
  response: DevelopmentEnquiryFormUpsertMutationResponse,
|};
*/


/*
mutation DevelopmentEnquiryFormUpsertMutation(
  $input: CreateEnquiryInput!
) {
  createEnquiry(input: $input) {
    enquiry {
      id
    }
    errors {
      productId
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateEnquiryPayload",
    "kind": "LinkedField",
    "name": "createEnquiry",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Enquiry",
        "kind": "LinkedField",
        "name": "enquiry",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EnquiryErrors",
        "kind": "LinkedField",
        "name": "errors",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "productId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DevelopmentEnquiryFormUpsertMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DevelopmentEnquiryFormUpsertMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "140b7cead1cfaebae307ba07f3be2fa4",
    "id": null,
    "metadata": {},
    "name": "DevelopmentEnquiryFormUpsertMutation",
    "operationKind": "mutation",
    "text": "mutation DevelopmentEnquiryFormUpsertMutation(\n  $input: CreateEnquiryInput!\n) {\n  createEnquiry(input: $input) {\n    enquiry {\n      id\n    }\n    errors {\n      productId\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e326198d6749b48612283490190d5031';

export default node;
